import React, {useState} from "react";
import './surveyComponent.css';
import {Built} from "../domain/built";
import {WorksDone} from "../domain/worksDone";
import {AtticAmenagment} from "../domain/atticAmenagment";
import {useNavigate} from "react-router-dom";
import {Survey} from "../domain/survey";
import {createAdvise} from "../adapters/createAdvise";

export function SurveyComponent() {


    const navigate = useNavigate();

    const [_built, setBuilt] = useState(Built.Unknown)
    const [_worksDone, setWorkDone] = useState(new Array<WorksDone>())
    const [_atticAmenagment, setAtticAmenagment] = useState(AtticAmenagment.Unknown)

    const [data, setData] = useState([]);


    return (
        <div className='Survey'>
            <h1>Des conseils de rénovation personnalisés <br></br> pour votre maison individuelle en 3 clics&nbsp;!</h1>
            <p className='intro'>L'outil en ligne "Bingo Réno" vous
                aide à prioriser
                les travaux de rénovation à réaliser dans votre maison.
                L'objectif : réaliser des économies d'énergie et gagner en confort ! Cet outil simple et rapide a
                été développé par <a href="https://www.grenoblealpesmetropole.fr" target="_blank">Grenoble
                    Alpes Métropole</a> et l'<a href="https://www.alec-grenoble.org" target="_blank">Agence Locale de
                    l'Énergie et du Climat (ALEC)</a>.
            </p>
            <h2>1. Quelle est la période de construction de votre maison ? <span className="red-star">*</span></h2>
            <div className='Survey-choice'>
                <button
                    className={'Radio-button ' + isBuiltChecked(Built.Before1945)}
                    onClick={onBuiltRadioClick(Built.Before1945)}
                >Avant 1945
                </button>
                <button
                    className={'Radio-button ' + isBuiltChecked(Built.Between1945and1980)}
                    onClick={onBuiltRadioClick(Built.Between1945and1980)}
                >1945-1980
                </button>
                <button
                    className={'Radio-button ' + isBuiltChecked(Built.Between1980and2000)}
                    onClick={onBuiltRadioClick(Built.Between1980and2000)}>1981-2000
                </button>
                <button
                    className={'Radio-button ' + isBuiltChecked(Built.After2000)}
                    onClick={onBuiltRadioClick(Built.After2000)}>Après 2000
                </button>
            </div>
            <div className='Survey-separator'></div>
            <h2>2. Quels travaux avez-vous déjà effectué ces 20 dernières années (plusieurs réponses
                possibles) ? <span
                    className="red-star">*</span></h2>
            <div className='Survey-choice'>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.RoofIsolation)}
                    onClick={onWorksDoneClick(WorksDone.RoofIsolation)}
                >Isolation du toit
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.FloorIsolation)}
                    onClick={onWorksDoneClick(WorksDone.FloorIsolation)}
                >Isolation du sol
                </button>

                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.WallInternalIsolation)}
                    onClick={onWorksDoneClick(WorksDone.WallInternalIsolation)}
                >Isolation des murs
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.WindowIsolation)}
                    onClick={onWorksDoneClick(WorksDone.WindowIsolation)}
                >Installation de fenêtres en double ou triple vitrage
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.CentralHeatingChange)}
                    onClick={onWorksDoneClick(WorksDone.CentralHeatingChange)}
                >Changement du système de chauffage central
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.WoodBurnerChange)}
                    onClick={onWorksDoneClick(WorksDone.WoodBurnerChange)}
                >Installation ou changement d'un poêle ou d'un insert de cheminée
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.ChauffeEau)}
                    onClick={onWorksDoneClick(WorksDone.ChauffeEau)}
                >Installation ou changement d'un chauffe-eau
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.PanneauSolaire)}
                    onClick={onWorksDoneClick(WorksDone.PanneauSolaire)}
                >Installation de panneaux solaires photovoltaïques
                </button>
                <button
                    className={'Radio-button ' + isWorksSelected(WorksDone.InstallOrChangeVMC)}
                    onClick={onWorksDoneClick(WorksDone.InstallOrChangeVMC)}
                >Installation ou changement d'un système de ventilation (VMC)
                </button>
                <button
                    className={isNoWorkDoneSelected() ? 'Radio-button Radio-button-checked' : 'Radio-button'}
                    onClick={onNoWorkDoneClick()}
                >Aucun travaux
                </button>
            </div>
            <div className='Survey-separator'></div>
            <h2>3. Si vous avez un grenier, est-il aménagé ? <span className="red-star">*</span></h2>
            <div className='Survey-choice'>
                <button
                    className={'Radio-button ' + isAtticSelected(AtticAmenagment.Converted)}
                    onClick={onAtticClick(AtticAmenagment.Converted)}
                ><p><strong>Oui</strong></p><img className="small-image" src="./combleok.png"
                                                 alt="Combles aménagés"/>
                </button>
                <button
                    className={'Radio-button ' + isAtticSelected(AtticAmenagment.NotConverted)}
                    onClick={onAtticClick(AtticAmenagment.NotConverted)}
                ><p><strong>Non</strong></p><img className="small-image"
                                                 src="./combles-non-amenages.png"
                                                 alt="Combles non aménagés"/>
                </button>

            </div>


            <div className="Survey-command">
                <button className="Action-Button"
                        onClick={calculate(_built, _atticAmenagment)}
                        disabled={!canCalculate()}>C'est parti !
                </button>


            </div>
            <p className='mandatory'><span className="red-star">*</span> Champs obligatoires</p>

        </div>
    );


    function canCalculate() {
        return _built !== Built.Unknown && _worksDone.length > 0 && _atticAmenagment !== AtticAmenagment.Unknown;
    }

    // Cette fonction est appelée lorsque l'utilisateur clique sur un bouton correspondant à une période de construction.
    // Elle met à jour l'état `_built` pour correspondre à la période de construction sélectionnée.


    function onBuiltRadioClick(built: Built) {
        return () => {
            setBuilt(built);
            let filteredData;
            switch (built) {
                case Built.Before1945:
                    filteredData = data.filter(item => item["QUESTIONS POSEES"] === "Avant 80");
                    break;
                case Built.Between1945and1980:
                    filteredData = data.filter(item => item["QUESTIONS POSEES"] === "Avant 80");
                    break;
                case Built.Between1980and2000:
                    filteredData = data.filter(item => item["QUESTIONS POSEES"] === "80 - 2000");
                    break;
                case Built.After2000:
                    filteredData = data.filter(item => item["QUESTIONS POSEES"] === "Apres 2000");
                    break;
                default:
                    filteredData = data;
            }


        };
    }

    // Cette fonction vérifie si une période de construction spécifique est égale à l'état `_built`.
    // Si c'est le cas, elle renvoie la chaîne 'Radio-button-checked', sinon elle renvoie une chaîne vide.
    function isBuiltChecked(built: Built) {
        return _built === built ? 'Radio-button-checked' : '';
    }

    // Cette fonction vérifie si un travail spécifique est inclus dans l'état `_worksDone`.
    // Si c'est le cas, elle renvoie la chaîne 'Radio-button-checked', sinon elle renvoie une chaîne vide.
    function isWorksSelected(work: WorksDone) {
        return _worksDone.includes(work) ? 'Radio-button-checked' : '';
    }

    function isNoWorkDoneSelected() {
        return _worksDone.length === 1 && _worksDone[0] === WorksDone.None;
    }

    function onNoWorkDoneClick() {
        return (e: React.MouseEvent<HTMLButtonElement>) => {
            setWorkDone([WorksDone.None])
        }
    }

    // Cette fonction est appelée lorsque l'utilisateur clique sur un bouton correspondant à un travail spécifique.
    // Si le travail est déjà inclus dans `_worksDone`, il est retiré. Sinon, il est ajouté à `_worksDone`.
    function onWorksDoneClick(work: WorksDone) {

        return (e: React.MouseEvent<HTMLButtonElement>) => {
            let newWorksDone: any;
            if (_worksDone.includes(work)) {
                newWorksDone = _worksDone.filter(w => w !== work);
            } else {
                newWorksDone = _worksDone.concat(work);
            }
            setWorkDone(newWorksDone);


        };
    }

    // Cette fonction vérifie si un aménagement de grenier spécifique est égal à l'état `_atticAmenagment`.
    // Si c'est le cas, elle renvoie la chaîne 'Radio-button-checked', sinon elle renvoie une chaîne vide.
    function isAtticSelected(attic: AtticAmenagment) {
        return _atticAmenagment === attic ? 'Radio-button-checked' : '';
    }

    // Cette fonction est appelée lorsque l'utilisateur clique sur un bouton correspondant à un aménagement de grenier spécifique.
    // L'état `_atticAmenagment` est mis à jour pour correspondre à l'aménagement de grenier sélectionné.
    function onAtticClick(attic: AtticAmenagment) {
        return (e: React.MouseEvent<HTMLButtonElement>) => {
            setAtticAmenagment(attic)
        }
    }

    // Cette fonction est appelée lorsque l'utilisateur clique sur le bouton pour calculer le résultat.
    // Elle navigue vers la page '/result' et passe un nouvel objet `BingoRenoAdvise` comme état.
    function calculate(built: Built, atticAmenagment: AtticAmenagment) {
        return async () => {

            let survey = new Survey(built, _worksDone, atticAmenagment);
            let bingoRenoAdvise = createAdvise(survey);
            navigate('?result=A', {state: JSON.stringify(bingoRenoAdvise)});
            window.scroll(0, 0)
        }
    }


}

